module.exports = __webpack_public_path__ + "img/image129.2bc2e5fa.png";